import * as React from 'react'
import { PropsWithChildren, ReactElement, ReactNode } from 'react'
import { Icon, IFontStyles, IIconProps, mergeStyleSets, Stack, StackItem, Text } from '@fluentui/react'
import { mergeStyles } from '@fluentui/react/lib/Styling'

export type IconValueProps = {
    value?: ReactNode
    valueUrl?: string
    iconName?: string
    iconProps?: IIconProps
    icon?: React.JSX.Element
    indent?: number
    wrap?: boolean
    textVariant?: keyof IFontStyles
    wrapperClassName?: string
}

const classNames = mergeStyleSets({
    stack: { minWidth: 0 },
    stackv9: { minWidth: 0, fontSize: '1.5em' },
    wrapper: { alignSelf: 'center' },
    icon: { flexShrink: '0 !important', minWidth: 16, overflow: 'visible' },
    label: { overflow: 'hidden' },
})

export default function IconValue(props: PropsWithChildren<IconValueProps>): ReactElement {
    return (
        <Text
            variant={props.textVariant}
            className={mergeStyles(classNames.wrapper, props.wrapperClassName || {})}
            styles={{
                root: {
                    width: props.wrap ? '100%' : 'auto',
                    paddingLeft: `${props.indent || 0}em`,
                    cursor: 'default',
                    userSelect: 'none',
                },
            }}
            block
            nowrap={!props.wrap}
        >
            <Stack
                horizontal
                tokens={{ childrenGap: 's2' }}
                verticalAlign="center"
                className={props.icon ? classNames.stackv9 : classNames.stack}
            >
                {(props.iconName || props.iconProps) && (
                    <Icon iconName={props.iconName} {...props.iconProps} className={classNames.icon} />
                )}
                {props.icon}
                <Stack horizontal tokens={{ childrenGap: 's1' }} className={classNames.stack}>
                    <StackItem className={classNames.label}>{props.value}</StackItem>
                    <StackItem>{props.children}</StackItem>
                </Stack>
            </Stack>
        </Text>
    )
}
